module.exports = __webpack_public_path__ + "2d7366a6ae42d0e5b20a9a8738d00788.jpg";